export const AdminPermissions = {
  // Cross-organisation access (Super Admin / Org Owner). Gates creating
  // document types. Adjusting flow config is gated on DOCTYPE_MANAGE.
  CROSS_ORG: "admin.crossOrg",

  // Category
  CATEGORY_MANAGE: "admin.category.manage",
  CATEGORY_VIEW: "admin.category.view",

  // Dashboard
  DASHBOARD_VIEW: "admin.dashboard.view",

  // Doctype
  DOCTYPE_MANAGE: "admin.doctype.manage",
  DOCTYPE_VIEW: "admin.doctype.view",

  // Evaluation
  EVALUATION_TRIGGER: "admin.evaluation.trigger",
  EVALUATION_VIEW: "admin.evaluation.view",

  // Monitoring
  MONITORING_VIEW: "admin.monitoring.view",

  // Provider
  PROVIDER_VIEW: "admin.provider.view",
  PROVIDER_CREDENTIAL_MANAGE: "admin.provider.credential.manage",
  PROVIDER_CREDENTIAL_VIEW: "admin.provider.credential.view",
  PROVIDER_MODEL_MANAGE: "admin.provider.model.manage",
  PROVIDER_MODEL_VIEW: "admin.provider.model.view",
} as const;

export type AdminPermission =
  (typeof AdminPermissions)[keyof typeof AdminPermissions];
